angular.module('app').factory('monitoringService', [
    'Restangular',
    'settings',
    function (Restangular, settings) {
        var restAngular = Restangular.withConfig(function (Configurer)
        {
            Configurer.setBaseUrl(settings.apiURL);
        });

        restAngular = restAngular.all("/monitoring/");

        return {
            getSkins: function () {
                return restAngular.one("getSkins").get();
            },
            switchToMaintenance: function (requestData) {
                return restAngular.one("switchToMaintenance").post("", requestData)
            },
            switchToLive: function (requestData) {
                return restAngular.one("switchToLive").post("", requestData)
            }
        }
    }
]);
